import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { AuthGuard } from './auth/auth.guard';
import { ErrorComponent } from '@app/error/error.component';
import { VenuesIndexComponent } from './venues/index/venues-index.component';
import { VenueEditComponent } from './venues/edit/venue-edit.component';
import { VenueResolver } from './venues/shared/venue.resolver';
import { VenueViewComponent } from './venues/view/venue-view.component';
import { ProductsIndexComponent } from './products/index/products-index.component';
import { UsersIndexComponent } from './users/index/users-index.component';
import { SuppliersIndexComponent } from './suppliers/index/suppliers-index.component';
import { ProductEditComponent } from './products/edit/product-edit.component';
import { ProductViewComponent } from './products/view/product-view.component';
import { ProductResolver } from './products/shared/product-resolver';
import { UserEditComponent } from './users/edit/user-edit.component';
import { UserResolver } from './users/shared/user-resolver';
import { SupplierEditComponent } from './suppliers/edit/supplier-edit.component';
import { SupplierResolver } from './suppliers/shared/supplier-resolver';
import { EventsIndexComponent } from './events/index/events-index.component';
import { EventEditComponent } from './events/edit/event-edit.component';
import { EventResolver } from './events/shared/event-resolver';
import { AuthLayoutComponent } from '@app/layouts/auth-layout/auth-layout.component';
import { EventViewComponent } from '@app/events/view/event-view.component';
import { EventTimelineItemResolver } from '@app/events/shared/event-timeline-item-resolver';
import { EventsCalendarComponent } from '@app/calendar/events-calendar.component';
import { BoardComponent } from '@app/board/view/board.component';
import { VenuePricesCalendarComponent } from '@app/venues/prices/venue-prices-calendar.component';
import { ContactsIndexComponent } from '@app/contacts/index/contacts-index.component';
import { ContactEditComponent } from '@app/contacts/edit/contact-edit.component';
import { DashboardComponent } from '@app/dashboard/dashboard.component';

export const routes: Routes = [
  // Routes with AuthLayout
  {
    path: '',
    component: AuthLayoutComponent, // Wrapping auth routes with AuthLayoutComponent
    children: [
      { path: 'login', component: LoginComponent },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    ],
    data: { roles: ['*'] },
  },

  // Routes with AppLayout
  {
    path: '',
    component: AppLayoutComponent, // Wrapping app routes with AppLayoutComponent
    children: [
      // Dashboard
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: { roles: ['*'] },
      },
      {
        path: 'error',
        component: ErrorComponent,
        canActivate: [AuthGuard],
        data: { roles: ['*'] },
      },

      // Venues
      /*{
        path: 'venues',
        component: VenuesIndexComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
      },
      {
        path: 'venues/:id/edit',
        component: VenueEditComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
        resolve: { venue: VenueResolver },
      },
      {
        path: 'venues/:id/prices/calendar',
        component: VenuePricesCalendarComponent,
        resolve: {
          venue: VenueResolver,
        },
      },
      {
        path: 'venues/:id/view',
        component: VenueViewComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
        resolve: { venue: VenueResolver },
      },
      {
        path: 'venues/create',
        component: VenueEditComponent,
        data: { roles: ['admin'] },
        canActivate: [AuthGuard],
      },
*/
      // Products
      {
        path: 'products',
        component: ProductsIndexComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },
      {
        path: 'products/:id/edit',
        component: ProductEditComponent,
        canActivate: [AuthGuard],
        resolve: { product: ProductResolver },
        data: { roles: ['admin'] },
      },
      {
        path: 'products/:id/view',
        component: ProductViewComponent,
        canActivate: [AuthGuard],
        resolve: { product: ProductResolver },
        data: { roles: ['admin', 'manager', 'staff'] },
      },
      {
        path: 'products/create',
        component: ProductEditComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },

      // Users
      {
        path: 'users',
        component: UsersIndexComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },

      {
        path: 'users/:id/edit',
        component: UserEditComponent,
        resolve: { user: UserResolver },
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },
      {
        path: 'users/create',
        component: UserEditComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },

      // Contacts
      {
        path: 'contacts',
        component: ContactsIndexComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },
      {
        path: 'contacts/:id/edit',
        component: ContactEditComponent,
        resolve: { user: UserResolver },
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },
      {
        path: 'contacts/create',
        component: ContactEditComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },

      // Suppliers
     /* {
        path: 'suppliers',
        component: SuppliersIndexComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },
      {
        path: 'suppliers/:id/edit',
        component: SupplierEditComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
        resolve: { supplier: SupplierResolver },
      },
      {
        path: 'suppliers/create',
        component: SupplierEditComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin'] },
      },

      // Events
      {
        path: 'events',
        component: EventsIndexComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
      },
      {
        path: 'events/create',
        component: EventEditComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
      },
      {
        path: 'events/:id',
        component: EventViewComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
        resolve: { event: EventResolver },
      },
      {
        path: 'events/:id/timeline/:timelineItemId',
        component: EventViewComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
        resolve: { event: EventResolver, timelineItem: EventTimelineItemResolver },
      },
      {
        path: 'events/:id/edit',
        component: EventEditComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
        resolve: { event: EventResolver },
      },

      // Calendar
      {
        path: 'events-calendar',
        component: EventsCalendarComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
      },

      // Board
      {
        path: 'board',
        component: BoardComponent,
        canActivate: [AuthGuard],
        data: { roles: ['admin', 'manager', 'staff'] },
      },*/
    ],
  },

  // Wildcard route
  { path: '**', redirectTo: '/dashboard' },
];
